import { FluxTag } from '../tag';
import { PagingConfig } from './gb-paging';

export interface Pager extends FluxTag<PagingConfig> { }

export class Pager {

  init() {
    this._scopeTo('gb-paging');
    this._config = this._scope._config;
  }
}



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/tags/paging/gb-pager.ts
 **/